import { useEffect, useRef } from 'react';

/**
 * Get previous value
 */
const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T>(undefined);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

// **** Export **** //

export default usePrevious;
